import styled from "styled-components";
import { SwipeableDrawer, Button, Typography } from "@mui/material";
import { theme } from "../../utils/globalStyles/colors";
import Logo from "../../utils/globalStyles/logo/logo.png";
import DownloadIcon from "@mui/icons-material/Download";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ShareIcon from "@mui/icons-material/Share";

/* Bottom sheet: sobe de baixo como nos apps nativos e fecha arrastando */
export const Sheet = styled(SwipeableDrawer)`
  & .MuiDrawer-paper {
    width: 100%;
    max-width: 480px;
    max-height: 92vh;
    max-height: 92dvh;
    margin: 0 auto;
    border-radius: 20px 20px 0 0;
    overflow-y: auto;
    box-sizing: border-box;
    background-color: #f7f9fc;
    padding: 0 16px calc(16px + env(safe-area-inset-bottom));
  }
`;

export const Handle = styled.div`
  width: 40px;
  height: 5px;
  border-radius: 3px;
  background-color: #d5d8dd;
  margin: 10px auto 12px;
  flex-shrink: 0;
`;

export const ReceiptContainer = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px 24px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  position: relative;
`;

export const HeaderReceipt = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
`;

export const Image = styled.div`
  width: 64px;
  height: 64px;
  background-image: url(${Logo});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 16px;
`;

export const SuccessIcon = styled(CheckCircleIcon)`
  color: #28a745;
  font-size: 40px !important;
  margin-bottom: 8px;
`;

export const Title = styled(Typography)`
  font-weight: 800 !important;
  color: #f37214;
  font-size: 20px !important;
  text-align: center;
`;

export const DateText = styled(Typography)`
  color: #888888;
  font-size: 14px !important;
  margin-top: 4px !important;
`;

export const ValueHighlight = styled(Typography)`
  font-weight: 800 !important;
  color: #f37214;
  font-size: 36px !important;
  margin: 16px 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 2px dashed #cccccc;
  margin: 24px 0;
`;

export const DataRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const Label = styled(Typography)`
  color: #666666;
  font-size: 14px !important;
  font-weight: 600 !important;
`;

export const Value = styled(Typography)`
  color: #333333;
  font-size: 14px !important;
  font-weight: 800 !important;
  text-align: right;
`;

/* ÁREA DOS BOTÕES */
export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
  box-sizing: border-box;
`;

/* Organiza os botões principais lado a lado */
export const RowButtons = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const ShareButton = styled(Button)`
  background-color: #25d366 !important; /* Cor do WhatsApp para remeter a compartilhamento */
  color: #ffffff !important;
  border-radius: 12px !important;
  height: 54px !important;
  font-weight: bold !important;
  font-size: 14px !important;
  text-transform: none !important;
  flex: 1 !important; /* Divide o espaço igualmente com o botão de baixar */
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.2) !important;

  &:hover {
    opacity: 0.9;
    box-shadow: 0 6px 16px rgba(37, 211, 102, 0.3) !important;
  }
`;

export const DownloadButton = styled(Button)`
  background-color: ${theme.colors.base} !important;
  color: #ffffff !important;
  border-radius: 12px !important;
  height: 54px !important;
  font-weight: bold !important;
  font-size: 14px !important;
  text-transform: none !important;
  flex: 1 !important;
  box-shadow: 0 4px 12px rgba(192, 90, 33, 0.2) !important;

  &:hover {
    opacity: 0.9;
    box-shadow: 0 6px 16px rgba(192, 90, 33, 0.3) !important;
  }
`;

export const CloseButton = styled(Button)`
  background-color: transparent !important;
  color: #777777 !important;
  border-radius: 12px !important;
  height: 48px !important;
  font-weight: 700 !important;
  font-size: 15px !important;
  text-transform: none !important;
  width: 100% !important;

  &:active {
    background-color: #eceff3 !important;
  }
`;

export const DownIcon = styled(DownloadIcon)`
  margin-right: 6px;
  font-size: 20px !important;
`;

export const ShrIcon = styled(ShareIcon)`
  margin-right: 6px;
  font-size: 20px !important;
`;
